// extracted by mini-css-extract-plugin
export default {"quem":"Home_quem__ylB3Z","zaplogo":"Home_zaplogo__MHxhY","divmembros":"Home_divmembros__u-9LZ"};